//存储系统相关数据，拥有的菜单项、登陆用户
const actions={
    //设置系统名称
    setXtname(context,value){
      context.commit('SET_XTNAME',value);
    },
    //添加用户
    setIsCollapse(context,value){
        context.commit('SET_ISCOLLAPSE',value);
    },
    //添加用户
    setLoginUser(context,value){
        context.commit('SET_lOGIN_USER',value);
    },
    //
    setMyMenuTree(context,value){
        context.commit('SET_MY_MENU',value)
    },
    setCzbtns(context,value){
      context.commit('SET_CZBTNS',value);
    },
    //全部清除
    setClearAll(context,value){
      context.commit('CLEAR_ALL',null)
    }
};
//准备mutations--响应组件中  修改state中的数据
const mutations={
    //设置系统名称
    SET_XTNAME(state,value){
      // console.log('执行了',value)
      state.xtname=value;
    },
    //设置左侧菜单是否折叠
    SET_ISCOLLAPSE(state,value){
        // console.log('执行了',value)
        state.isCollapse=value;
    },
    //设置用户
    SET_lOGIN_USER(state,value){
        state.loginUser=value;
    },
    //设置菜单
    SET_MY_MENU(state,value){
      // console.log("SET_MY_MENU>>",value)
      state.myMenuTree=value;
    },
    //设置当前激活的菜单
    SET_ACTIVE_MENU(state,value){
        state.activeMenu=value;
    },
    SET_CZBTNS(state,value){
      // console.log("SET_CZBTNS>>",value)
      state.czbtns=value;
    },
    //清除所有数据
    CLEAR_ALL(state,value){
      // console.log("全部清除了",state)
      //使用一次就清楚清除session
      window.sessionStorage.clear();
      window.localStorage.clear();
      state.isCollapse=false;//控制左侧菜单是否折叠，
      state.activeMenu='';//当前激活的菜单
      state.stateloginUser= null;//当前登陆用户
      state.myMenuTree=[];//当前用户具有的菜单权限
      state.xtname='';
      state.czbtns=[];
    }
};
//准备state对象，保存具体的数据
const state=initData();
//getter
const getters={
  getXtname(){
    return state.xtname;
  },
    getIsCollapse(){
        return state.isCollapse;
    },
    getMyMenuTree(){
        return state.myMenuTree;
    },
    getLoginUser(){
        return state.loginUser;
    },
    getActiveMenu(){
      // console.log("读取activeMenu>>",state.activeMenu)
        return state.activeMenu;
    },
    getRouters(){//根据左侧菜单生成，路由文件
      // console.log('state.myMenuTree',state.myMenuTree)
      let tmp_routes=[];
      if(state.myMenuTree!=null && state.myMenuTree.length){
        tmp_routes=eachRouteChildren(state.myMenuTree)
      }
      return tmp_routes;
    },
    getCzbtns(){//获取操作按钮权限
    if(state.czbtns==null || state.czbtns.length==0){
      return [];
    }
    return state.czbtns;
  }
}


const sysAbout={
    namespaced:true,
    actions,
    mutations,
    state,
    getters
}

//用来初始化数据
function initData(){
  let initState= {
    czbtns:[],//当前用户具有的按钮权限
    stateloginUser: null,//当前登陆用户
    isCollapse:false,//控制左侧菜单是否折叠，
    activeMenu:window.sessionStorage.getItem('activeMenu')? window.sessionStorage.getItem('activeMenu'): '',//当前激活的菜单
    loginUser:window.sessionStorage.getItem('loginUser')? JSON.parse(window.sessionStorage.getItem('loginUser')): null,//当前登陆用户
    myMenuTree:window.sessionStorage.getItem('myMenuTree')? JSON.parse(window.sessionStorage.getItem('myMenuTree')): [],//当前用户具有的菜单权限
    xtname:window.sessionStorage.getItem('xtname')? window.sessionStorage.getItem('xtname'): ''
  }

  // console.log('state-初始化》》》',initState)
  //使用一次就清楚清除session
  window.sessionStorage.clear();
  window.localStorage.clear();

  return initState;
}

function eachRouteChildren(dataList){
  let children=[];
  if(dataList!=null && dataList.length){
    dataList.forEach(item=>{
      if (item.path!='#'){
        // console.log('path>>>',item.path)
        children.push(
          {
            name:item.name,
            path:item.path,
            meta:{title:item.title,czbtns:item.czbtns},
            component: () => import('../' + item.component),
            children:eachRouteChildren(item.children)
          }
        )
      }else if(item.children!=null && item.children.length){
        children.push(...eachRouteChildren(item.children));
      }
    })

  }
  return children;
}

export default sysAbout;



// WEBPACK FOOTER //
// ./src/store/sys.js